import {decorate, observable} from 'mobx';
import {faExternalLinkAlt} from '@fortawesome/free-solid-svg-icons';
import {BaseModel} from './base';

export class ExternalResource extends BaseModel {
  static faIcon = faExternalLinkAlt;

  searchableProperties = ['name', 'description', 'method', 'url', 'additionalHeaders'];

  populateAttributesFromStore(rootStore) {
    super.populateAttributesFromStore(rootStore);
  }

  get additionalHeadersFormatted() {
    return this.additionalHeaders ? JSON.stringify(this.additionalHeaders, null, 1) : null;
  }
}

decorate(ExternalResource, {
  id: observable,
  name: observable,
  description: observable,
  method: observable,
  url: observable,
  additionalHeaders: observable,
});

export const ExternalResourceIds = Object.freeze({
  InspectionReload: 1,
});
